import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import QRCode from "react-qr-code";
import { CouponPosFetchAPI } from '../../api/Paymentpost/Coupon';
import { DiscountPosFetchAPI } from '../../api/Paymentpost/Discount';
import ErrorAlert from '../Alerts/ErrorAlert';
import { FaTicketAlt } from 'react-icons/fa';
import Socket from '../utils/Socket.config';
import { preserveKitchenStateFromSource } from '../../utils/PreOrderPaymentPrint';


function ModalCoupons({ actvPlus, actvLite, shoppingCart, shoppingCartCombos, total, subtotal, itbms, discount, setLoad, setShoppingCart, taxesArrayAll }) {
   let title_modal = "Cupones "
   const [show, setShow] = useState(false);
   let { business_code, branchoffice_code } = useParams();
   const [valueInput, setValueInput] = useState("");
   const [orderCuponTemp, setOrderCuponTemp] = useState({})
   const [session, setSession] = useState(0);
   let machine = JSON.parse(localStorage.getItem('machine'))
   let token = localStorage.getItem('x-access-machine-token');


   function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
   }


   //
   const auhtCupon = async (code) => {
      console.log(code);
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      try {
         const response = await CouponPosFetchAPI.getCupon(code, token)

         let branchofficeArray = response.data.data.branchoffice;
         var data_filter = branchofficeArray.filter(element => element.code == branchoffice.code)
         console.log(data_filter);
         if (data_filter.length > 0) {
            console.log("El cupon si es valido");
            createTempDiscountCupon(code)
         } else {
            let icon = "warning"
            let title = "Cupon denegado."
            let message = "El cupon no es valido en esta sucursal"
            ErrorAlert(message, title, icon)
         }

      } catch (err) {
         ErrorAlert('', 'Error no se puedo aplicar el cupon', 'error')
         console.log(err);

      }
   }

   //create orders temporal of discount type cupon
   const createTempDiscountCupon = async (code) => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let token = localStorage.getItem('x-access-machine-token');
      let jsonDiscountTemp = {
         "client_name": "0",
         "cupon_code": code,
         "is_cupon": true,
         "localizador": "0",
         "client_phone": "0",
         "dgi_qr": "0",
         "Orden": shoppingCart,
         "combos": shoppingCartCombos,
         "Descuento": "0",
         "Total": total,
         "itbms": itbms,
         "taxes": taxesArrayAll,
         "subtotal": subtotal,
         "machine_id": machine.id,
         "branchoffice_id": branchoffice.id,
         "tipoOrden": "comer aqui",
         "paymethod": 0,
         "is_discount_notification": true
      }
      try {
         const response = await DiscountPosFetchAPI.createTempDiscount(jsonDiscountTemp, token)
         if (response.data.message == 'Tempral order created') {
            getOrdersTempDiscount()
         }
      } catch (err) {
         ErrorAlert('', 'Error no se puedo aplicar el cupon', 'error')
         console.log(err);
      }
   }

   // get order temporal discount
   const getOrdersTempDiscount = async () => {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let business = JSON.parse(localStorage.getItem('business'))

      let token = localStorage.getItem('x-access-machine-token');
      try {
         const response = await DiscountPosFetchAPI.getTempDiscount(machine.code, business.code, branchoffice.code, token)

         let code = response.data.order.code
         let message = "Descuento aplicado con exito."
         let title = "Operacion exitosa"
         let icon = "success"

         let tempOrderDiscount = preserveKitchenStateFromSource(response.data.order.groups, shoppingCart)

         setOrderCuponTemp(response.data.order);
         console.log(response.data.order);
         //format json 
         for (let i = 0; i < tempOrderDiscount.length; i++) {
            for (let s = 0; s < tempOrderDiscount[i].segments.length; s++) {
               tempOrderDiscount[i].segments[s].item_id = tempOrderDiscount[i].segments[s].item.item_id
               tempOrderDiscount[i].segments[s].name = tempOrderDiscount[i].segments[s].item.name
               tempOrderDiscount[i].segments[s].cantidadItem = tempOrderDiscount[i].segments[s].item.amount
               tempOrderDiscount[i].segments[s].description = tempOrderDiscount[i].segments[s].item.description
               tempOrderDiscount[i].segments[s].img = tempOrderDiscount[i].segments[s].item.img
            }
            tempOrderDiscount[i].DetalleSegmentos = tempOrderDiscount[i].segments
            tempOrderDiscount[i].cantidadItem = tempOrderDiscount[i].amount
            tempOrderDiscount[i].descuento = tempOrderDiscount[i].discount
         }

         setShoppingCart(tempOrderDiscount)
         setLoad(1)
         updateOrderDiscount(code, 3, message, title, icon)
         setShow(false)
      } catch (err) {
         console.log(err);
      }
   }

   //update orders temporal discount
   const updateOrderDiscount = async (code, status, message, title, icon) => {
      console.log(code);
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let business = JSON.parse(localStorage.getItem('business'))

      let jsonUpdate = {
         "order_code": code,
         "business_code": business.code,
         "branchoffice_code": branchoffice.code,
         "status": status
      }
      try {
         const response = await DiscountPosFetchAPI.updateOrderTemp(jsonUpdate, token)
         console.log(response);
         ErrorAlert(message, title, icon)
      } catch (err) {
         console.log(err);
      }

   }




   //function to aply cupon
   const aplyCupon = async () => {

      let message = ""
      let title = ""
      let icon = ""
      if (discount > 0) {
         message = "No se pueden aplicar dos descuentos"
         title = "Ya existe un descuento aplicado."
         icon = "warning"
         ErrorAlert(message, title, icon)

      } else {


         let valueUpperCase = valueInput.toUpperCase();
         let arrayInput = valueUpperCase.split("X");
         let codeCupon = arrayInput[1]
         auhtCupon(codeCupon)
      }
   }

   useEffect(() => {

      if (show == true) {
         // Connection with the sockets server


         const socket = Socket({ "business_code": business_code, "branchoffice_code": branchoffice_code, "machine_code": machine.code });
         // we upate the data when the server send the signal of a new order 

         // Escuchar la validación del cupón
         socket.on('cuponValidated', (response) => {

            console.log(response);
            if (response.success) {
               // Mostrar cupón válido
               ErrorAlert("Cupon validado", response.message, "success");
            } else {
               // Mostrar error
               ErrorAlert("Cupón inválido", response.message, "error");
            }

         });

         return () => {
            socket.disconnect();
         }
      }
   }, [show]);

   return (
      <>

         <button className=' p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary' onClick={() => (setShow(true), setSession(getRandomInt(0, 9999)))}>
            <i className="uil uil-ticket icon "></i>
            <small className='fw-bold text '>
               Cupones
            </small>
         </button>

         <Modal
            show={show}
            size="md"
            onHide={() => setShow(false)}
            aria-labelledby="example-custom-modal-styling-title"
            centered
         >
            <div className='mt-2 text-center p-1'>
               <h4 className='fw-bold'>  <i className="uil uil-ticket " ></i> {title_modal} </h4>
            </div>
            <Modal.Body>
               {/* <div className="input-group input-group-lg">
                  <input type="text" className="form-control" placeholder='Ingrese código de cupón' onChange={(e) => (setValueInput(e.target.value))} />
               </div> */}

               {/*<div className="mb-3">
                  <input type="text" class="form-control border " id="floatingInput" placeholder="Ingrese código de cupón"/>
               </div>*/}

               {/* <div className='d-flex justify-content-between mt-3'>
                  <button className='btn btn-danger btn-lg' onClick={() => setShow(false)}> Cancelar </button>
                  <button className='btn btn-success btn-lg' onClick={() => aplyCupon()}> Aplicar  </button>
               </div> */}

               {/*<div className='d-flex justify-content-between justify-content-lg-end  mt-2'>

                  <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                     onClick={() => setShow(false)}> Cancelar </button>


                  <button className='btn bg-success-subtle text-success fw-bold border-0  ms-1'
                     onClick={() => aplyCupon()}> Aplicar Cupón </button>
               </div>*/}



               {/*-----*/}

               <div className="m-4 d-flex align-items-center justify-content-center ">

                  <QRCode
                     value={JSON.stringify({ business: business_code, branchoffice: branchoffice_code, machine: machine.code, session: session, token: token })} // Asegúrate de que siempre haya texto
                     size={200} // Tamaño del QR
                     bgColor="#ffffff" // Color de fondo
                     fgColor="#000000" // Color del texto
                     level="H" // Nivel de corrección de errores
                  />
               </div>
               <div className="bg-light border-sp d-flex align-items-center justify-content-center ">
                  <div >
                     <h1 className='text-center'>Sesion:{session}</h1>

                     <div className=" col-md-12 d-flex  p-2 text-center" >
                        <span className="text-muted border border-2 rounded-3 p-1  w-100 bg-light"> Escanea el qr para aplicar el cupon<br></br>
                           <span translate='no' className='fw-bold'></span>
                        </span>
                     </div>
                  </div>

               </div>
            </Modal.Body>
         </Modal>


      </>
   )
}

export default ModalCoupons
